import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ImageEdit from '@blade-sxp/device-management-pass/components/image-edit/index.vue';
import { getBackground, updateBackground } from '@blade-sxp/pass/api/access-management/device-management';
import { handleError } from '@blade/common/utils/handle-error';
let default_1 = class extends Vue {
    vipBackup = '';
    nonVipBackup = '';
    vipSrc = '';
    vipFormat = '';
    nonVipSrc = '';
    nonVipFormat = '';
    pixel = {
        minWidth: 800,
        maxWidth: 800,
        minHeight: 1280,
        maxHeight: 1280,
    };
    isVipChange = false;
    isNonVipChange = false;
    mounted() {
        this.getBackground();
    }
    getBackground() {
        getBackground()
            .then((res) => {
            const data = res;
            if (data.length) {
                if (data[0].type === 'VIP') {
                    this.vipSrc = data[0].imageUrl;
                    this.vipBackup = data[0].imageUrl;
                    if (data[1]) {
                        this.nonVipSrc = data[1].imageUrl;
                        this.nonVipBackup = data[1].imageUrl;
                    }
                }
                else {
                    this.nonVipSrc = data[0].imageUrl;
                    this.nonVipBackup = data[0].imageUrl;
                    if (data[1]) {
                        this.vipSrc = data[1].imageUrl;
                        this.vipBackup = data[1].imageUrl;
                    }
                }
            }
        });
    }
    updateBackground(image, format, type) {
        updateBackground({ image, format, type })
            .then(res => {
            this.$message.success(`${this.$t('deploySuc')}`);
            if (type === 'VIP') {
                this.vipBackup = this.vipSrc;
            }
            else {
                this.nonVipBackup = this.nonVipSrc;
            }
        }).catch(() => {
            if (type === 'VIP') {
                this.vipSrc = this.vipBackup;
            }
            else {
                this.nonVipSrc = this.nonVipBackup;
            }
        });
    }
    getVipBase64(base64, format) {
        this.vipSrc = base64;
        this.vipFormat = format;
        this.isVipChange = true;
    }
    getNonVipBase64(base64, format) {
        this.nonVipSrc = base64;
        this.nonVipFormat = format;
        this.isNonVipChange = true;
    }
    handleDeploy(type) {
        this.$elconfirm(`${this.$t('deployConfirm').toString()}`, `${this.$t('common.warning')}`, {
            type: 'warning',
            center: true,
            callback: async (action) => {
                if (action === 'confirm') {
                    try {
                        if (type === 'VIP') {
                            this.updateBackground(this.vipSrc, this.vipFormat, type);
                        }
                        else {
                            this.updateBackground(this.nonVipSrc, this.nonVipFormat, type);
                        }
                    }
                    catch (e) {
                        handleError(e);
                    }
                }
                else {
                    if (type === 'VIP') {
                        this.vipSrc = this.vipBackup;
                    }
                    else {
                        this.nonVipSrc = this.nonVipBackup;
                    }
                }
                if (type === 'VIP') {
                    this.isVipChange = false;
                }
                else {
                    this.isNonVipChange = false;
                }
            },
        });
    }
};
default_1 = __decorate([
    Component({
        name: 'BackgroundManagement',
        components: { ImageEdit },
        i18n: {
            messages: {
                'en-us': {
                    leftTitle: 'Member Background',
                    rightTitle: 'Non-member Background',
                    deploy: 'Deploy Image',
                    deployTip: 'Effective for all online and offline devices',
                    deploySuc: 'Deploy Successfully',
                    deployConfirm: 'Are you sure to deploy the background picture?',
                },
                zh: {
                    leftTitle: '会员背景图',
                    rightTitle: '非会员背景图',
                    deploy: '下发图片',
                    deployTip: '对所有在线设备及离线设备均生效',
                    deploySuc: '下发成功',
                    deployConfirm: '是否确认下发新背景图片？（所有设备均会下发）',
                },
            },
        },
    })
], default_1);
export default default_1;
